import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UPLOAD_ANALYSIS_STEP, UPLOAD_STATUS } from '@src/globals';
import {
  StatusType,
  UploadMediaAnalysisState,
  UploadMediaAnalysisType,
} from '@src/types/main';

const initialState: UploadMediaAnalysisState = {
  uploadMediaInfo: {
    inputType: '',
    originalFileName: '',
    url: '',
    locale: '',
    base64: '',
    id: '',
  },
  status: UPLOAD_STATUS.IDLE,
  analysisStep: UPLOAD_ANALYSIS_STEP.INITIAL,
};

const uploadMediaSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setUploadedMediaInfo(
      state,
      action: PayloadAction<UploadMediaAnalysisType>
    ) {
      state.uploadMediaInfo.inputType = action.payload.inputType;
      state.uploadMediaInfo.originalFileName = action.payload.originalFileName;
      state.uploadMediaInfo.url = action.payload.url;
      state.uploadMediaInfo.locale = action.payload.locale;
      state.uploadMediaInfo.base64 = action.payload.base64;
      state.uploadMediaInfo.id = action.payload.id;
    },

    resetUploadedMediaInfo(state) {
      state.uploadMediaInfo.inputType = '';
      state.uploadMediaInfo.originalFileName = '';
      state.uploadMediaInfo.url = '';
      state.uploadMediaInfo.locale = '';
      state.uploadMediaInfo.base64 = '';
      state.uploadMediaInfo.id = '';
    },

    setStatus(state, action: PayloadAction<StatusType>) {
      state.status = action.payload;
    },

    setAnalysisStep(state, action: PayloadAction<number>) {
      state.analysisStep = action.payload;
    },

    resetUploadMedia(state) {
      state.uploadMediaInfo.inputType = '';
      state.uploadMediaInfo.originalFileName = '';
      state.uploadMediaInfo.url = '';
      state.uploadMediaInfo.locale = '';
      state.uploadMediaInfo.base64 = '';
      state.uploadMediaInfo.id = '';
      state.status = UPLOAD_STATUS.IDLE;
      state.analysisStep = UPLOAD_ANALYSIS_STEP.INITIAL;
    },
  },
});

export const {
  setUploadedMediaInfo,
  resetUploadedMediaInfo,
  setStatus,
  setAnalysisStep,
  resetUploadMedia,
} = uploadMediaSlice.actions;

export default uploadMediaSlice.reducer;
